import { wrap } from './wrap-idb-value';
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
export function openDB(name, version, _a) {
    var _b = _a === void 0 ? {} : _a, blocked = _b.blocked, upgrade = _b.upgrade, blocking = _b.blocking, terminated = _b.terminated;
    var request = indexedDB.open(name, version);
    var openPromise = wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', function (event) {
            upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction));
        });
    }
    if (blocked)
        request.addEventListener('blocked', function () { return blocked(); });
    if (terminated)
        request.addEventListener('close', function () { return terminated(); });
    if (blocking) {
        openPromise
            .then(function (db) { return db.addEventListener('versionchange', blocking); })
            .catch(function () { });
    }
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
export function deleteDB(name, _a) {
    var blocked = (_a === void 0 ? {} : _a).blocked;
    var request = indexedDB.deleteDatabase(name);
    if (blocked)
        request.addEventListener('blocked', function () { return blocked(); });
    return wrap(request).then(function () { return undefined; });
}
export { unwrap, wrap } from './wrap-idb-value';
